export default {
  cookies: {
    title: 'Мы уважаем вашу конфиденциальность',
    description:
      'Мы используем файлы cookie для корректной работы сайта, анализа посещаемости и улучшения сервиса. Вы можете принять или отклонить использование cookie. Ваш выбор можно изменить позже.',
    accept: 'Принять все',
    reject: 'Отклонить',
    privacy_policy: 'Политика конфиденциальности'
  }
}
